export const AWS_REGION = process.env.NEXT_PUBLIC_AWS_REGION as string;
export const COGNITO_IDENTITY_POOL_ID = process.env.NEXT_PUBLIC_COGNITO_IDENTITY_POOL_ID as string;
export const COGNITO_USER_POOL_ID = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID as string;
export const COGNITO_APP_CLIENT_ID = process.env.NEXT_PUBLIC_COGNITO_APP_CLIENT_ID as string;
export const COGNITO_DOMAIN = process.env.NEXT_PUBLIC_COGNITO_DOMAIN as string;

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_RULE_LOWERCASE = 'lowercaseLetters';
export const PASSWORD_RULE_UPPERCASE = 'uppercaseLetters';
export const PASSWORD_RULE_NUMBERS = 'numbers';
export const PASSWORD_RULE_SPECIAL_CHARACTERS = 'specialCharacters';
export const PASSWORD_IS_NEW = 'new';
